import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0015',
    ecrans: ['00-2'],
    params: ['id',
            '?niveau',
            '?elecleint',
            '?vaesysnatctb',
            '?anncivfin',
            '?peccoddeb',
            '?peccodfin',
            '?indcleint']
});
